export default class IndicadoresService {
  constructor($q, UIService, AuthenticationService, AuthorizationService, ParametrosDiversos) {
    this.$q = $q;
    this.UI = UIService;
    this.Auth = AuthenticationService;
    this.AuthorizationService = AuthorizationService;
    this.ParametrosDiversos = ParametrosDiversos;
    this.user = this.Auth.getUser();
  }

  countDecimals = (n) => {
    if (isNaN(n) || Math.floor(n) === n) return 0;
    return n.toString().split(".")[1].length || 0;
  };

  getAnos = () => {
    let anos = [];
    let firstYear = 2021;
    let lastYear = moment().format('YYYY');
    for (let i = firstYear; i <= lastYear; i++) {
      anos.push({ano: i});
    }
    return anos;
  };

  getQuadro = (numero, ano) => {
    let defer = this.$q.defer();
    let quadro;
    switch(numero) {
      case 0: quadro = this.ParametrosDiversos.getPromotingScientificExcellence; break;
      case 1: quadro = this.ParametrosDiversos.getPromotingCollaborationInterdisciplinaryResearch; break;
      case 2: quadro = this.ParametrosDiversos.getPromotingResponsibleResearchInnovation; break;
      case 3: quadro = this.ParametrosDiversos.getDeliveringEducationTraining; break;
      case 4: quadro = this.ParametrosDiversos.getEnhancingInternationalCollaborationCooperation; break;
      case 5: quadro = this.ParametrosDiversos.getPromotingResearchImpactSociety; break;
      case 6: quadro = this.ParametrosDiversos.getFosteringOutreachPublic; break;
      case 7: quadro = this.ParametrosDiversos.getPromotingVitalitySustainabilityResearchEnvironment; break;
      case 8: quadro = this.ParametrosDiversos.getManagingSustainedSuccessOrganization; break;
      default: defer.reject();
    }

    quadro({ano: ano}).$promise.then((data) => {
      defer.resolve(data);
    }).catch(error => {
      console.log(error);
      defer.reject(error);
    });
    return defer.promise;
  };
}

IndicadoresService.$inject = ['$q', 'UIService', 'AuthenticationService', 'AuthorizationService', 'ParametrosDiversos'];
